/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Prep_TipsInputs */



/**
* | output |
* | --- |
* | "Conversation tips" |
*
* @param {Chat_Quick_Prep_TipsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_prep_tips = /** @type {((inputs?: Chat_Quick_Prep_TipsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Prep_TipsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekstips")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conseils de conversation")
	return /** @type {LocalizedString} */ ("Conversation tips")
});